import { type Ari, AnyAri } from '@atlassian/ari';

/**
 *  Parses a JSON string and returns the result. If the JSON string is invalid, it returns undefined.
 * @param data - a JSON string
 * @returns the parsed JSON object if JSON is valid and successfully parsed to JSON, otherwise undefined
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const safeParseJson = (data: string | undefined): any => {
	if (!data) {
		return undefined;
	}
	try {
		return JSON.parse(data);
	} catch {
		return undefined;
	}
};

export const addQueryParam = (url: string, key: string, value: string): string => {
	try {
		const urlObj = new URL(url);
		urlObj.searchParams.set(key, value);
		return urlObj.toString();
	} catch {
		// If URL is invalid, return original URL
		return url;
	}
};

export const isValidUrl = (value: string): boolean => {
	if (!value) {
		return false;
	}

	try {
		new URL(value);
		return true;
	} catch {
		return false;
	}
};

export const parseAriSafely = (ari?: unknown): Ari | null => {
	if (typeof ari !== 'string') return null;

	try {
		const result = AnyAri.parse(ari);
		return result;
	} catch (error) {
		return null;
	}
};
